import { Card, CardContent, CardHeader, Skeleton, Stack, Typography } from '@mui/material'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { observer } from 'mobx-react-lite'
import MonthSelector from './Elements/MonthSelector'
import RankSelector from './Elements/RankSelector'
import CompleteBoxes from './Elements/CompleteBoxes'
import PointDetail from './Elements/PointDetail'
import Legs from './Elements/Legs'
import StoreAchievement from './StoreAchievement'

const SuccessTracker = observer(() => {
    const translate = useTranslate()
    const isLoading = StoreAchievement.getAchievements().length === 0

    return (
        <Card
            sx={{
                '&.MuiPaper-root': {
                    borderRadius: '8px'
                }
            }}
            elevation={0}>
            <CardHeader
                title={
                    <Typography variant="h6" color="rgba(56, 66, 80, 1)" fontSize={'18px'} fontWeight={400} textAlign={'center'} lineHeight={'1'}>
                        {translate('success')}
                    </Typography>
                }
                sx={{
                    backgroundColor: 'rgba(233, 241, 250, 1)',
                    paddingY: '12px'
                }}
            />
            <CardContent sx={{ padding: '20px 16px' }}>
                {isLoading ? (
                    <SuccessTrackerSkeleton />
                ) : (
                    <Stack direction={'column'} gap="20px">
                        <MonthSelector />
                        <RankSelector />
                        <CompleteBoxes />
                        <PointDetail />
                        <Legs />
                    </Stack>
                )}
            </CardContent>
        </Card>
    )
})

const SuccessTrackerSkeleton = () => {
    return (
        <Stack direction={'column'} gap="20px">
            {/* MonthSelector Skeleton */}
            <Stack direction={'row'} gap="24px" justifyContent={'center'}>
                <Skeleton variant="text" width={40} height={24} />
                <Skeleton variant="text" width={40} height={24} />
                <Skeleton variant="text" width={40} height={24} />
            </Stack>

            {/* RankSelector Skeleton */}
            <Skeleton variant="rounded" width={'100%'} height={50} sx={{ borderRadius: '8px' }} />

            {/* CompleteBoxes Skeleton */}
            <Stack gap={2} alignItems={'center'}>
                <Stack direction={'row'} gap={'12px'}>
                    <Skeleton variant="rounded" width={140} height={40} sx={{ borderRadius: '12px' }} />
                    <Skeleton variant="rounded" width={140} height={40} sx={{ borderRadius: '12px' }} />
                </Stack>
                <Stack direction={'row'} gap={'12px'}>
                    <Skeleton variant="rounded" width={90} height={40} sx={{ borderRadius: '12px' }} />
                    <Skeleton variant="rounded" width={90} height={40} sx={{ borderRadius: '12px' }} />
                    <Skeleton variant="rounded" width={90} height={40} sx={{ borderRadius: '12px' }} />
                </Stack>
            </Stack>

            {/* PointDetail Skeleton */}
            <Stack gap={'8px'}>
                {[1, 2, 3, 4, 5].map(item => (
                    <Stack key={item} direction={'row'} justifyContent={'space-between'}>
                        <Skeleton variant="text" width={60} height={20} />
                        <Skeleton variant="text" width={80} height={20} />
                    </Stack>
                ))}
            </Stack>

            {/* Legs Skeleton */}
            <Stack gap={'12px'}>
                {[1, 2, 3].map(item => (
                    <Skeleton key={item} variant="rounded" width={'100%'} height={30} sx={{ borderRadius: '8px' }} />
                ))}
            </Stack>
        </Stack>
    )
}

export default SuccessTracker
